import { FC } from 'react';
import { Button, Card, Col, Form, InputNumber, Row } from "antd";
import * as React from "react";

import SelectPublishField from '../fields/select-publish-field';
import { useSearchParams } from 'react-router-dom';
import SelectMarketField from '../fields/select-market-field';

interface Prop {
	onFinish: (data: any) => any
}

const CreditPackFilter: FC<Prop> = ({ onFinish }) => {
	const [form] = Form.useForm();
	const [searchParams] = useSearchParams()

	React.useEffect(() => {
		form.setFieldValue("market", searchParams.get("market"))
		form.setFieldValue("published", searchParams.get("published"))
		onFinish(form.getFieldsValue())
	}, [])

	return (
		<Card style={{ marginBottom: "16px" }}>
			<Form form={form} onFinish={onFinish} layout="horizontal"  autoComplete='off'>
				<Row gutter={16}>

					<Col xs={24}  md={12} xl={6}  >
						<Form.Item name="market" label="مارکت">
							<SelectMarketField allowClear />
						</Form.Item>
					</Col>

					<Col xs={24}  md={12} xl={6}  >
						<Form.Item name="published" label="انتشار" 	>
							<SelectPublishField allowClear />
						</Form.Item>
					</Col>

					<Col span={24} style={{ textAlign: 'left' }}>
						<Button type="primary" htmlType="submit">جستجو</Button>
					</Col>
				</Row>
			</Form>
		</Card>
	)
}

export default CreditPackFilter;
